import { PackageGeneralFormWebComponent } from './component/PackageGeneralFormWebComponent';
import { WEB_COMPONENT_PACKAGE_GENERAL_FORM } from '../../../webcomponents.constants';

export { PackageGeneralFormWebComponent };

window.customElements.define(WEB_COMPONENT_PACKAGE_GENERAL_FORM, PackageGeneralFormWebComponent);
